import React from 'react';
import './Music.css';

const questCategories = ['Esports', 'Startups', 'Tools', 'Content', 'Random Quests'];

const quests = [
  {
    title: 'Esports',
    subtitle: 'Still in the game',
    description:
      'Still active in international esports: team operations, partnerships and events across APAC, EMEA and NA',
    emoji: '🎮',
    link: { label: '@Keshav4M on X', url: 'https://x.com/Keshav4M' },
  },
  {
    title: 'Building my own startups',
    subtitle: 'Idea to MVP',
    description:
      'Exploring my own product ideas and taking the promising ones from idea to a deployed MVP',
    emoji: '🚀',
  },
  {
    title: 'SafeTools',
    subtitle: 'safetools.online',
    description:
      'Free, privacy-first toolkit for everyday PDF, image and video tasks, built and run solo',
    emoji: '🛠️',
    link: { label: 'Visit safetools.online', url: 'https://safetools.online/' },
  },
  {
    title: 'More small tools',
    subtitle: 'Always shipping',
    description:
      'A growing set of small, useful tools; new ones land on GitHub first',
    emoji: '🧰',
    link: { label: 'See GitHub', url: 'https://github.com/MKeshav04?tab=repositories' },
  },
  {
    title: 'Content creation',
    subtitle: 'Currently in stealth 🤫',
    description:
      "Started creating content. You can't see it yet, it's in stealth mode. Working on speaking on camera, one take at a time",
    emoji: '🎬',
  },
  {
    title: 'Side quests with friends',
    subtitle: 'Say yes to random',
    description:
      "If a friend throws javelin, I'll learn javelin with them. Always up for a new side quest, sometimes I just need someone to go on one with",
    emoji: '🧭',
  },
];

const SideQuests: React.FC = () => {
  return (
    <div className="music-page">
      <div className="quote">
        <p>Outside the day job: what I'm running, building and shipping on the side.</p>
      </div>

      <div className="genre-section">
        <h3>Explore by Quest</h3>
        <div className="genres">
          {questCategories.map((category, index) => (
            <div key={index} className="genre-card" style={{ animationDelay: `${index * 0.2}s` }}>
              <p>{category}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="albums-section">
        <h3>Side Quests</h3>
        <div className="albums">
          {quests.map((quest, index) => (
            <div key={index} className="album-card" style={{ animationDelay: `${index * 0.3}s` }}>
              <div className="album-details" style={{ padding: '1.5rem', textAlign: 'center' }}>
                <h4 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{quest.emoji}</h4>
                <h4>{quest.title}</h4>
                <p style={{ opacity: 0.8, marginBottom: '0.75rem' }}>{quest.subtitle}</p>
                <p style={{ fontSize: '0.9rem', lineHeight: 1.5 }}>{quest.description}</p>
                {quest.link && (
                  <p style={{ marginTop: '0.75rem' }}>
                    <a
                      href={quest.link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#e50914', fontWeight: 600, textDecoration: 'none' }}
                    >
                      {quest.link.label} →
                    </a>
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SideQuests;
